jQuery(function($){
  var grid = false;
  $(window).on('resize', function(){
    window.requestAnimationFrame(function(){
      if (window.matchMedia('(min-width: 1024px)').matches) {
        if (!grid) {
          $('.testimonials-grid__wrapper').colcade({
            columns: '.testimonials-grid__col',
            items: '.testimonials-grid__item'
          });
          grid = true;
        }
      } else {
        if (grid) {
          $('.testimonials-grid__wrapper').colcade('destroy');
          grid = false;
        }
      }
    });
  }).trigger('resize');

  $('.js-testimonials').on('click', function(){
    var page = parseInt($(this).data('page') + 1);
    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: {
        'action': 'get_testimonials',
        'page': page,
      }
    }).done(function(response){
      var res = JSON.parse(response);
      if (window.matchMedia('(min-width: 1024px)').matches){
        $('.testimonials-grid__wrapper').colcade('append', $(res.content));
        $('.testimonials-grid__wrapper').colcade('reload');
      }
      if (res.lastpage) {
        $('.js-testimonials').css('display', 'none');
      }
      else {
        $('.js-testimonials').css('display', 'inline-block');
      }
      $('.js-testimonials').data('page', page);
    });
  });
});
